import { motion } from "framer-motion"

export const defaultVariant = {
    initial: {
        // opacity: 0
    },
    animate: {
        // opacity: 1,
        // transition: {
        //     duration: .5,
        //     type: 'tween'
        // }
    },
    exit: {
        // opacity: 0,
        // transition: {
        //     duration: .5,
        //     type: 'tween'
        // }
    },
}

export const slideVariant = {
    initial: {
        x: '-100%'
    },
    animate: {
        x: 0,
        transition: {
            type: 'spring',
            damping: 20
        }
    },
    exit: {
        x: '-110%',
        transition: {
            type: 'spring',
            damping: 20
        }
    },
}

export const reversedSlideVariant = {
    initial: {
        x: '100%'
    },
    animate: {
        x: 0,
        transition: {
            type: 'spring',
            damping: 20
        }
    },
    exit: {
        x: '110%',
        transition: {
            type: 'spring',
            damping: 20
        }
    },
}

const Transition = ({ children, type = "fade", reversed = false }) => {
    const variant = type === 'slide' ? (reversed ? reversedSlideVariant : slideVariant) : defaultVariant

    return (
        <motion.div
            variants={variant}
            initial="initial"
            animate="animate"
            exit="exit"
        >
            {children}
        </motion.div>
    )
}

export default Transition